module.exports = __webpack_public_path__ + "img/福化集团.fdc3e3a9.png";